export default __webpack_public_path__ + "static/media/session_details_140x140.20938665.jpg";